import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    tab_container: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        padding: theme.spacing(2),
    },
    box: {
        backgroundColor: theme.palette.common.white,
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: 4,
        padding: 16,
        minHeight: 250,
    },
    filter_box: {
        backgroundColor: theme.palette.common.white,
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: 4,
        padding: 16,
        marginBottom: '15px',
        display: 'flex',
        justifyContent: 'space-between',
    },
    datepicker: {
        width: '350px',
    },
    summary_box: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[2],
    },
    summary_title: {
        fontSize: 18,
        fontWeight: 600,
        marginBottom: 16,
        color: theme.palette.text.primary,
        borderBottom: `2px solid ${theme.palette.primary.main}`,
        paddingBottom: 12,
    },
    summary_content: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
    },
    summary_item: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '8px 0',
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
        '&:last-child': {
            borderBottom: 'none',
        }
    },
    summary_label: {
        fontSize: 14,
        color: theme.palette.text.secondary,
        fontWeight: 500,
    },
    summary_value: {
        fontSize: 16,
        fontWeight: 700,
        color: theme.palette.text.primary,
    },
    profit_positive: {
        color: theme.palette.success.main,
    },
    profit_negative: {
        color: theme.palette.error.main,
    }
}));

export {useStyles}